import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from '../components/Sidebar';
import TopNav from '../components/TopNav';
import { academicService } from '../services/api';
import { Card, Select, Field, EmptyState, Spinner } from '../components/ui';
import ModulePaymentPlans from '../components/ModulePaymentPlans';
import ModuleCoupons from '../components/ModuleCoupons';

function PaymentPlans() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedModuleId = searchParams.get('module') || '';

  useEffect(() => {
    academicService.getMyModules()
      .then((res) => {
        const data = res.data;
        const list = Array.isArray(data) ? data : data.results || [];
        setModules(list);
        if (!selectedModuleId && list.length > 0) {
          setSearchParams({ module: String(list[0].id) }, { replace: true });
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-screen bg-surface-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopNav title={t('Payment Plans')} subtitle={t('Custom pricing plans and discount coupons for your courses')} />
        <main className="flex-1 overflow-y-auto p-6 space-y-6">
          {loading ? (
            <div className="p-12 flex justify-center"><Spinner /></div>
          ) : modules.length === 0 ? (
            <Card><EmptyState title={t('No courses yet')} description={t('Create a course first, then come back here to add payment plans and coupons for it.')} /></Card>
          ) : (
            <>
              <Card>
                <Field label={t('Course')}>
                  <Select
                    value={selectedModuleId}
                    onChange={(e) => setSearchParams({ module: e.target.value })}
                  >
                    {modules.map((m) => (
                      <option key={m.id} value={m.id}>{m.name} ({m.code})</option>
                    ))}
                  </Select>
                </Field>
              </Card>

              {selectedModuleId && (
                <>
                  <ModulePaymentPlans moduleId={selectedModuleId} />
                  <ModuleCoupons moduleId={selectedModuleId} />
                </>
              )}
            </>
          )}
        </main>
      </div>
    </div>
  );
}

export default PaymentPlans;
